import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

import ManageIncomingMailContainer from "../../../containers/ManageIncomingMailsContainer/ManageIncomingMailsContainer";
const ManageIncomingMail = () => {
  const tRP = "components.incoming_mail";
  const { t } = useTranslation();
  const [portalHeader, setPortalHeader] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setPortalHeader(document.getElementById("Title-screen"));
  }, []);

  return (
    <>
      {portalHeader &&
        ReactDOM.createPortal(
          <>
            <Typography
              variant="h3"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {`${t(`${tRP}.title`)}`}
            </Typography>
          </>,
          portalHeader
        )}
      <ManageIncomingMailContainer />
    </>
  );
};
export default ManageIncomingMail;
